// extracted by mini-css-extract-plugin
export default {"root":"CountdownTimer_root__dMSy1","number":"CountdownTimer_number__QfHtr","label":"CountdownTimer_label__3chEL","separator":"CountdownTimer_separator__xqWB8"};